import React from 'react';
import { AlertTriangle } from 'lucide-react';

const Disclaimer = () => (
  <div
    data-testid="result-disclaimer"
    className="mt-6 rounded-xl border border-amber-200 bg-amber-50/60 p-4 flex gap-3 text-amber-900"
  >
    <AlertTriangle size={18} className="shrink-0 mt-0.5 text-amber-600" />
    <p className="text-xs leading-relaxed">
      Train running status, coach position, chart preparation, and platform number are
      compiled from crowd-sourced data and may vary. For final confirmation, please
      recheck at the station on the day of travel. This information is not endorsed by
      Indian Railways or IRCTC, and TrainPanda accepts no liability for its use.
    </p>
  </div>
);

export default Disclaimer;
